import Rust from "./rust_components/Rust.jsx";
import Rust_Arrays from "./rust_components/Rust_Arrays.jsx";
import Rust_Booleans from "./rust_components/Rust_Booleans.jsx";
import Rust_Borrowing from "./rust_components/Rust_Borrowing.jsx";
import Rust_Certificate from "./rust_components/Rust_Certificate.jsx";
import Rust_Comments from "./rust_components/Rust_Comments.jsx";
import Rust_Constants from "./rust_components/Rust_Constants.jsx";
import Rust_DataStructures from "./rust_components/Rust_DataStructures.jsx";
import Rust_DataTypes from "./rust_components/Rust_DataTypes.jsx";
import Rust_Enums from "./rust_components/Rust_Enums.jsx";
import Rust_ForLoops from "./rust_components/Rust_ForLoops.jsx";
import Rust_Functions from "./rust_components/Rust_Functions.jsx";
import Rust_GetStarted from "./rust_components/Rust_GetStarted.jsx";
import Rust_HashMap from "./rust_components/Rust_HashMap.jsx";
import Rust_Home from "./rust_components/Rust_Home.jsx";
import Rust_IfElse from "./rust_components/Rust_IfElse.jsx";
import Rust_Intro from "./rust_components/Rust_Intro.jsx";
import Rust_Loops from "./rust_components/Rust_Loops.jsx";
import Rust_Match from "./rust_components/Rust_Match.jsx";
import Rust_Operators from "./rust_components/Rust_Operators.jsx";
import Rust_Output from "./rust_components/Rust_Output.jsx";
import Rust_Ownership from "./rust_components/Rust_Ownership.jsx";
import Rust_Scope from "./rust_components/Rust_Scope.jsx";
import Rust_Strings from "./rust_components/Rust_Strings.jsx";
import Rust_Structs from "./rust_components/Rust_Structs.jsx";
import Rust_Syntax from "./rust_components/Rust_Syntax.jsx";
import Rust_Tuples from "./rust_components/Rust_Tuples.jsx";
import Rust_Variables from "./rust_components/Rust_Variables.jsx";
import Rust_Vectors from "./rust_components/Rust_Vectors.jsx";
import Rust_WhileLoops from "./rust_components/Rust_WhileLoops.jsx";

const AllRustComponents = {
  "<Rust />": Rust,
  "<Rust_Arrays />": Rust_Arrays,
  "<Rust_Booleans />": Rust_Booleans,
  "<Rust_Borrowing />": Rust_Borrowing,
  "<Rust_Certificate />": Rust_Certificate,
  "<Rust_Comments />": Rust_Comments,
  "<Rust_Constants />": Rust_Constants,
  "<Rust_DataStructures />": Rust_DataStructures,
  "<Rust_DataTypes />": Rust_DataTypes,
  "<Rust_Enums />": Rust_Enums,
  "<Rust_ForLoops />": Rust_ForLoops,
  "<Rust_Functions />": Rust_Functions,
  "<Rust_GetStarted />": Rust_GetStarted,
  "<Rust_HashMap />": Rust_HashMap,
  "<Rust_Home />": Rust_Home,
  "<Rust_IfElse />": Rust_IfElse,
  "<Rust_Intro />": Rust_Intro,
  "<Rust_Loops />": Rust_Loops,
  "<Rust_Match />": Rust_Match,
  "<Rust_Operators />": Rust_Operators,
  "<Rust_Output />": Rust_Output,
  "<Rust_Ownership />": Rust_Ownership,
  "<Rust_Scope />": Rust_Scope,
  "<Rust_Strings />": Rust_Strings,
  "<Rust_Structs />": Rust_Structs,
  "<Rust_Syntax />": Rust_Syntax,
  "<Rust_Tuples />": Rust_Tuples,
  "<Rust_Variables />": Rust_Variables,
  "<Rust_Vectors />": Rust_Vectors,
  "<Rust_WhileLoops />": Rust_WhileLoops,
};

export default AllRustComponents;
